import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      alignItems: 'flex-start',
    },
    icon: {
      color: COLORS.gray.gray30,
      marginRight: theme.spacing(1),
      height: 20,
      width: 20,
    },
    name: {
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      width: 520,
    },
    tags: {
      display: 'flex',
      flexWrap: 'wrap',
      minHeight: 12,
    },
    tag: {
      color: COLORS.gray.gray40,
      margin: theme.spacing(0.5, 0.25, 0, 0),
    },
  }),
  { name: 'ResourceMenuItem' }
);
